import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#6h19q300x__clip0_3_1087)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#kwh4qzv9u__clip1_3_1087)",
          children: [_jsx("rect", {
            width: "20",
            height: "20",
            fill: "white"
          }), _jsx("path", {
            d: "M-10 0H30V20H-10V0Z",
            fill: "#FF0000"
          }), _jsx("path", {
            d: "M-10 0H30V13.3333H-10V0Z",
            fill: "#005CE5"
          }), _jsx("path", {
            d: "M-10 0H30V6.66667H-10V0Z",
            fill: "white"
          }), _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.99844 4.50213C9.92462 4.50225 9.851 4.50376 9.77756 4.50589C8.34943 4.54291 7.00865 4.91171 6.05395 5.36149L6.05405 5.36278C5.94966 5.40641 5.8474 5.45016 5.75017 5.4939L6.07832 10.6339C6.30569 13.3199 8.05614 14.8838 10.001 15.4979C11.9459 14.8838 13.6962 13.3199 13.9236 10.6339L14.2499 5.51022C14.1525 5.45978 14.0503 5.4109 13.9461 5.36278L13.9462 5.36149C12.9427 4.88876 11.513 4.50478 10.0034 4.50224C10.0023 4.50223 10.0012 4.50213 10.0001 4.50213C9.99952 4.50213 9.99898 4.50213 9.99844 4.50213V4.50213Z",
            fill: "#005CE5"
          }), _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.09536 5.6824H9.3272L9.21364 5.48368L9.3272 5.28958H9.09536L8.98181 5.09548L8.86825 5.28958H8.63641L8.74997 5.48368L8.63641 5.6824H8.86825L8.98181 5.8765L9.09536 5.6824Z",
            fill: "#FFE500"
          }), _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.0353 5.6824H11.2625L11.1489 5.48368L11.2625 5.28958H11.0353L10.9171 5.09548L10.8035 5.28958H10.5717L10.6852 5.48368L10.5717 5.6824H10.8035L10.9171 5.8765L11.0353 5.6824Z",
            fill: "#FFE500"
          }), _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.1268 7.31405H10.3587L10.2404 7.11995L10.3587 6.92585H10.1268L10.0133 6.72713L9.89498 6.92585H9.66788L9.78143 7.11995L9.66788 7.31405H9.89498L10.0133 7.50815L10.1268 7.31405Z",
            fill: "#FFE500"
          }), _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.001 8.05969L9.04105 9.93426L8.42044 9.12804L6.7988 11.2711C6.8281 11.4041 6.86252 11.5325 6.90011 11.6579C7.08122 11.9636 7.42926 12.3125 7.87564 12.3125C8.22987 12.3125 8.5841 12.0292 8.93832 12.0292C9.29255 12.0292 9.64677 12.3125 10.001 12.3125C10.3552 12.3125 10.7095 12.0292 11.0637 12.0292C11.4179 12.0292 11.7721 12.3125 12.1264 12.3125C12.5687 12.3125 12.9144 11.9701 13.0969 11.6664C13.1359 11.5377 13.1709 11.4051 13.2011 11.2683L11.5816 9.12804L10.961 9.93426L10.001 8.05969ZM8.93832 12.3125C8.5841 12.3125 8.22987 12.5959 7.87564 12.5959C7.5953 12.5959 7.35446 12.4966 7.1679 12.3557C7.23378 12.4956 7.30347 12.6316 7.37973 12.7603C7.52587 12.8511 7.69195 12.9126 7.87564 12.9126C8.22987 12.9126 8.5841 12.6292 8.93832 12.6292C9.29255 12.6292 9.64677 12.9126 10.001 12.9126C10.3552 12.9126 10.7095 12.6292 11.0637 12.6292C11.4179 12.6292 11.7721 12.9126 12.1264 12.9126C12.3075 12.9126 12.4712 12.8525 12.6159 12.7638C12.6921 12.6355 12.7618 12.5 12.8277 12.3607C12.642 12.4989 12.4034 12.5959 12.1264 12.5959C11.7721 12.5959 11.4179 12.3125 11.0637 12.3125C10.7095 12.3125 10.3552 12.5959 10.001 12.5959C9.64677 12.5959 9.29255 12.3125 8.93832 12.3125V12.3125ZM8.93832 12.9126C8.5841 12.9126 8.22987 13.196 7.87564 13.196C7.79868 13.196 7.7255 13.187 7.65461 13.1733C8.26744 13.992 9.10352 14.54 10.0003 14.8552C10.8952 14.5405 11.73 13.9921 12.3424 13.1747C12.2731 13.1877 12.2015 13.196 12.1264 13.196C11.7721 13.196 11.4179 12.9126 11.0637 12.9126C10.7095 12.9126 10.3552 13.196 10.001 13.196C9.64677 13.196 9.29255 12.9126 8.93832 12.9126V12.9126Z",
            fill: "white"
          }), _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.99855 4.50211C9.92233 4.50222 9.84638 4.50382 9.77058 4.50608C9.84638 4.50406 9.9223 4.50222 9.99855 4.50211ZM6.05395 5.36276C5.94952 5.4064 5.84732 5.45012 5.75006 5.49387L6.07821 10.634C6.30558 13.32 8.05592 14.8838 10.0008 15.4979C11.9457 14.8838 13.696 13.32 13.9234 10.634L14.2497 5.51019C14.1523 5.45976 14.0501 5.41087 13.9458 5.36276L13.6413 10.4638C13.4302 13.0752 11.8054 14.5956 9.99994 15.1927C8.19447 14.5956 6.56954 13.0752 6.35848 10.4638L6.05395 5.36276Z",
            fill: "#FF0000"
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "6h19q300x__clip0_3_1087",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "kwh4qzv9u__clip1_3_1087",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            fill: "white"
          })
        })]
      })]
    }))
  });
};
export default Component;
